import FileDocumentIcon from './FileDocumentIcon';

export default FileDocumentIcon;
